import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiFillHeart } from "react-icons/ai";
import { BiCartAdd } from "react-icons/bi";
import { ProductContext } from "../../Contexts/ProductContext";
import { AuthContext } from "../../Contexts/AuthContext";
import {
  isProductInWishlist,
  addRemoveProductToWishlist,
} from "../../Utils/wishlistUtils";
import {
  addRemoveProductToCart,
  isProductInCart,
  handleProductQunatityInCart,
} from "../../Utils/cartUtils";
import "./WishlistCardStyle.css";
import Carousel from "../ProductCard/Carousel";
import PriceTag from "../global/PriceTag";
import { CartOperation } from "../../Utils/constant";
import { motion } from "framer-motion";

const WishlistCard = ({ product }) => {
  const { productState, productDispatch, orderState, orderDispatch } = useContext(ProductContext);
  const { authState } = useContext(AuthContext);

  const [cartBtnDisabled, setCartBtnDisabled] = useState(false);
  const [wishlistBtnDisabled, setWishlistBtnDisabled] = useState(false);
  const navigate = useNavigate();

  const isLogged = authState?.mobile?.length > 0;

  const removeFromWishlistHandler = (product) => {
    if (isLogged) {
      if (isProductInWishlist(productState?.wishlistIds, product?.prdId)) {
        addRemoveProductToWishlist(
          product,
          productDispatch,
          authState?.mobile,
          false,
          setWishlistBtnDisabled
        );
      }
    } else {
      navigate("/login");
    }
  };

  const addToCartHandler = (product) => {
    if (isLogged) {
      if (isProductInCart(productState?.cartIds, product?.prdId)) {
        handleProductQunatityInCart(
          product,
          true, productDispatch, orderState, orderDispatch, productState?.cart,
          setCartBtnDisabled
        )
      } else {
        addRemoveProductToCart(
          product,
          productDispatch,
          authState?.mobile,
          CartOperation.add,
          setCartBtnDisabled,
          productState?.cart
          , orderState, orderDispatch
        );
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <motion.div animate={{ y: [0, -8, 0] }}
        whileHover={{ rotate: -2, scale: 1.02 }}
        transition={{
          y: { duration: 1.8, repeat: Infinity, ease: "easeInOut" },
          rotate: { type: "spring", stiffness: 300, damping: 20 },
          scale: { type: "spring", stiffness: 300, damping: 20 }
        }} key={product.prdId} className="wishlist-product-card ">
        <div
          className="wishlist-product-img"
          onPointerDown={() => {
            if (!(product?.isOutOfStock ?? false)) {
              navigate("/view/products", { state: { inventory: product } });
            }
          }}
        >
          <center>
            <Carousel images={product.images} alt={product.name} />
          </center>
        </div>
        <div className="wishlist-product-body">
          <div className="wishlist-product-brand-review">
            <p className="wishlist-product-brand">{product.brand}</p>
          </div>
          <h1 className="wishlist-product-name">{product.name}</h1>
          <div className="wishlist-product-price">
            <PriceTag product={product} />
          </div>
          <button
            className={`wishlist-product-remove-btn pc-center ${wishlistBtnDisabled && "wishlist-product-remove-disabled"
              }`}
            onClick={() => removeFromWishlistHandler(product)}
            disabled={wishlistBtnDisabled}
          >
            <p className="pc-center">
              <AiFillHeart className="wishlist-product-icon" />
              Remove From Wishlist
            </p>
          </button>
          {!(product?.isOutOfStock ?? false) ? (
            <button
              className={`wishlist-product-cart-btn pc-center ${cartBtnDisabled && "wishlist-cart-disabled"
                }`}
              onClick={() => addToCartHandler(product)}
              disabled={cartBtnDisabled}
            >
              <p className="pc-center">
                <BiCartAdd className="wishlist-cart-icon" />
                Add To Cart
              </p>
            </button>) : (
            <div className="wishlist-out-of-stock-box pc-center">
              <span className="wishlist-out-of-stock-text">SOLD OUT</span>
            </div>
          )}
        </div>
      </motion.div>
    </>
  );
};
export { WishlistCard };
